import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const nomorOKService = {}

nomorOKService.data = function (token,data='') {
    console.log(data)
    return fetch({
        url: '/helpers/get_nomor_ok_aktif',
        method: 'get',
        params: {filter:data.filter,kode_ok:data.kode_ok},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default nomorOKService;
